/**
 * Ensure external anchors open in a new tab (fallback for any CMS HTML not processed server-side).
 */
export default function initExternalLinks() {
	const siteHost = window.location.hostname.toLowerCase();

	document.querySelectorAll('a[href]').forEach((anchor) => {
		const href = (anchor.getAttribute('href') || '').trim();
		if (!href || href === '#' || href.startsWith('#')) return;
		if (/^(mailto:|tel:|javascript:|sms:)/i.test(href)) return;

		let url;
		try {
			url = new URL(href, window.location.href);
		} catch {
			return;
		}

		if (!url.hostname || url.hostname.toLowerCase() === siteHost) return;
		if (anchor.target === '_blank') return;

		anchor.target = '_blank';
		anchor.rel = 'noopener noreferrer';
	});
}
